"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Join_1 = require("../../../helpers/Functions/Join");
/**
 * A generic collapse that can hide or show content with animation.
 */
var Collapse = function (_a) {
    var _b, _c;
    var _d = _a.expanded, expanded = _d === void 0 ? false : _d, labelledbyId = _a.labelledbyId, _e = _a.immediate, immediate = _e === void 0 ? false : _e, style = _a.style, className = _a.className, wrapperClassName = _a.wrapperClassName, wrapperStyle = _a.wrapperStyle, children = _a.children, testId = _a.testId;
    var _f = __read(React.useState({
        oriantationChanged: true,
    }), 2), state = _f[0], setState = _f[1];
    React.useEffect(function () {
        window.addEventListener("orientationchange", function (e) {
            e.stopPropagation();
            setTimeout(function () {
                setState({ oriantationChanged: !state.oriantationChanged });
            }, 10);
        });
    }, []);
    var wrapper = React.useRef(null);
    var expStyle = !immediate
        ? {
            maxHeight: expanded ? ((_b = wrapper.current) === null || _b === void 0 ? void 0 : _b.scrollHeight) + "px" : "0px",
            transition: "max-height 0.3s cubic-bezier(0.445, 0.05, 0.55, 0.95)",
        }
        : {
            maxHeight: expanded ? ((_c = wrapper.current) === null || _c === void 0 ? void 0 : _c.scrollHeight) + "px" : "0px",
        };
    return (React.createElement("div", { "data-testid": testId, style: __assign(__assign({}, expStyle), wrapperStyle), className: Join_1.join("rel", "overflow-hidden", wrapperClassName), "aria-labelledby": labelledbyId, role: "region" },
        React.createElement("div", { ref: wrapper, style: style, className: Join_1.join(className, "rel") }, children)));
};
exports.default = Collapse;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/containers/Collapse/Collapse.js
// module id = 674
// module chunks = 8